import React from "react";

import { Icons } from "../../data/Assets";

import { SVGIcon } from "../wrappers/SVGIcon";

export const SearchInput = () => {
    return (
        <div className="immersion__search_input__box">
            <SVGIcon src={Icons.Search} color="grey" />
            <input type="text" placeholder="Search/Ask AI" readOnly />
        </div>
    );
};